// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tagTaggedRecordEntity from './entities/tag-tagged-record.json';
import tagTaggedRecordMenu from '../pages/tag-tagged-record/menu.json';
import tagTaggedRecordFullForm from '../pages/tag-tagged-record/forms/full.json';
import tagTaggedRecordContextForm from '../pages/tag-tagged-record/forms/context.json';
import tagTaggedRecordMiniForm from '../pages/tag-tagged-record/forms/mini.json';
import tagTaggedRecordLookupForm from '../pages/tag-tagged-record/forms/lookup.json';
import tagTaggedRecordTableView from '../pages/tag-tagged-record/views/table.json';
import tagTaggedRecordCardsView from '../pages/tag-tagged-record/views/cards.json';
import tagTaggedRecordDashboardView from '../pages/tag-tagged-record/views/dashboard.json';

/** Тип запису «Позначений запис» зі сторінками пакета: меню, форми та подання з pages/tag-tagged-record/. */
export const tagTaggedRecordDefinition: IRecordTypeDefinition = {
  ...tagTaggedRecordEntity,
  views: assembleViewSet({
      table: tagTaggedRecordTableView,
      cards: tagTaggedRecordCardsView,
      dashboard: tagTaggedRecordDashboardView,
  }),
  form: tagTaggedRecordFullForm,
  forms: { full: tagTaggedRecordFullForm, context: tagTaggedRecordContextForm, mini: tagTaggedRecordMiniForm, lookup: tagTaggedRecordLookupForm },
  menu: tagTaggedRecordMenu,
} as IRecordTypeDefinition;
